import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { APPLY_ENROLL, SIGN_IN_EMAIL } from 'constants/pathNames';
import LoadingOverlay from 'components/LoadingOverlay';
import { verifyEmail } from 'services/post/authEmail';

const SignInEmailVerificationPage = (): ReactElement | null => {
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('mail');
    const hash = params.get('hash');

    const verificationEmail = async (): Promise<void> => {
      if (!email || !hash) return;
      try {
        const response = verifyEmail(email, hash).then((res) => {
          console.log('Email verification response:', res);
          localStorage.setItem('auth', JSON.stringify(res));
        });
        console.log('Email verification response:', response);
        message.success('Email verified successfully.');
        navigate(APPLY_ENROLL);
      } catch (error) {
        message.error('Failed to verify email. Please try again.');
        console.error('Email verification error:', error);
      } finally {
        setIsVerifying(false);
      }
    };

    if (email && hash) {
      verificationEmail();
    } else {
      message.error('Invalid verification link.');
      setIsVerifying(false);
      navigate(SIGN_IN_EMAIL);
    }
  }, [navigate]);

  if (isVerifying) {
    return <LoadingOverlay isLoading={isVerifying} />;
  }

  return null;
};

export default SignInEmailVerificationPage;
